export type TurboStripEventAction = (isNewBanner: boolean, bannerId: string, stripMsg: string) => void;

export interface TurboStripAnimation {
    messageList: string[];
    frequency: number;
}

export enum TurboStripType {
    STATIC = "STATIC",
    STATIC_INVERSE = "STATIC_INVERSE",
    DYNAMIC_SPLIT_PAY_INFO = "DYNAMIC_SPLIT_PAY_INFO",
}

export enum TurboStripCtaLink {
    PAYMENTS = "PAYMENTS",
    EMI = "EMI",
}

export interface TurboStripData {
    bannerId?: string;
    frequency?: number;
    isNewBanner?: boolean;
    iconUrl?: string;
    stripMsg?: string;
    animation?: TurboStripAnimation;
    type?: TurboStripType;
    cta?: {
        text?: string;
        link?: TurboStripCtaLink;
    };
}

export interface TurboEventMeta {
    discountText?: string;
    bankName?: string;
}
